import CostSharing from "./CostSharing";
import { LiaClinicMedicalSolid } from "react-icons/lia";
import { SLOT_NAMES } from '../../../utils/constants';

const step = 12
const StepTwelve = ({ activeStep, control, errors, setValue, getValues }) => {
    if (activeStep !== step) return;

    const template = getValues("template")
    const baseName = 'costShareBenefitDetails.preventiveCare';

    return (
        <>
            <div className="cost-sharing-box" >
                <CostSharing
                    name={`${baseName}.default.type`}
                    title={'Preventive Services'}
                    icon={LiaClinicMedicalSolid}
                    category={SLOT_NAMES.PREVENTIVE_SERVICES}
                    template={template}
                    inNetworkName={`${baseName}.default.type.inNetwork`}
                    outOfNetworkName={`${baseName}.default.outOfNetwork`}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    disabled={true}
                />
            </div>

            <div className="cost-sharing-box" >
                <CostSharing
                    name={`${baseName}.overwrite.type`}
                    title={'Preventive Services (Overwrite)'}
                    icon={LiaClinicMedicalSolid}
                    category={SLOT_NAMES.PREVENTIVE_SERVICES}
                    template={template}
                    inNetworkName={`${baseName}.overwrite.type.inNetwork`}
                    outOfNetworkName={`${baseName}.overwrite.outOfNetwork`}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    disabled={false}
                />
            </div>
        </>
    )
}

export default StepTwelve
